import { AccountTeam } from "./AccountTeam";
import { webConnect } from "core/redux";
import { getEmails } from "core/state/user/selectors";

export const ConnectedAccountTeam = webConnect(state => ({
  listTeam: getEmails(state)
}))(AccountTeam);
